<template>
    <div v-if="alert.message" :class="`alert ${ alert.type }`">
        {{ alert.message }}
        <button type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                @click="onClearAlert">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "AlertComponent",
        computed: {
            alert() {
                return this.$store.state.alert;
            }
        },
        methods: {
            onClearAlert() {
                this.$store.dispatch('alert/clear');
            }
        }
    }
</script>

<style scoped>

</style>